import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '@home/api'
import { mapGetters } from 'vuex'
import * as accountType from '@account/store/types'
import * as dateutil from '@appbase/util/date-helper';
import VueAES from '@/modules/@appbase/util/vue-aes'

interface systemLink{
  linkGrup:string,
  linkType:string,
  linkName:string,
  linkNameEn?:string,
  linkNameCn?:string,
  linkDescription:string,
  link:string,
  company?:string[]
}
interface systemCode{
  id:string,
  name:string,
  nameEn?:string,
  nameCn?:string,
  category?:string,
  originId:string,
  hasChild?:boolean,
  children?:Array<systemCode>|[],
  subName?:string
  company?:string[]
}

@Component({
  components: {  },
  computed: {
    ...mapGetters({
      current: accountType.CURRENT,
    })
  }
})
export default class TotalSystem extends Vue {
@Prop({type: Boolean, default: false}) isModal!:boolean
@Prop({type: String, default:''}) menuName!:string

  current!:account.TCurrent

  filteredLinkList:systemLink[]=[]
  selectedMenu:string = "LINK_TOTAL_SYSTEM_all"

  codeMenu:systemCode[]=[];
  title:string='';

  showTotalSystemAdmin: boolean = false;

  async clickLink(type:string,link:string){
    if(link==""){
      await (window as any).alertAsync('저장된 링크가 없습니다.')
      return
    }
    let moveTo = link
    if(type.startsWith('ezw')){
      api.home.getEncryptedParam(this.current.user.personId).then(res=>{
        moveTo += `?D1=${encodeURIComponent(res.split('&')[0])}&clientInfo=${res.split('&')[1]}`
        window.open(moveTo)
      })
    }
    else if(type.startsWith('slo')){
      // alert("연동 준비중")
      var date = dateutil.uGetDateFormat('yyyyMMDDHi',new Date())
      var token = `timestamp=${date}&comCode=${this.current.user.comCode}&personCode=${this.current.user.personId}&cefcjSsoId=${this.current.user.cjId!=''?this.current.user.cjId:'none'}`
      var aes = new VueAES(this.current.key)
      moveTo += `?comCode=${this.current.user.comCode}&token=${encodeURIComponent(aes.encrypt(token))}`
      window.open(moveTo,'_blank','width=1200,height=899');
    }
    else{
      window.open(moveTo,'_blank','width=1200,height=899')
    }

  }

  clickMenu(menu:systemCode){
    if(menu.hasChild) return
    this.selectedMenu = menu.originId;
  }

  openTotalSystemAdmin() {
    window.open('totalsystemAdmin', '_blank', 'width=1300,height=1280');
  }

  @Watch('selectedMenu')
  changedMenu(val:string){
    api.home.getList(val).then(res=>{
      if(res) {
        this.filteredLinkList = res.filter(r=>r.useYn).map(r=>{
                                return{
                                  linkGrup:r.groupId,
                                  linkType:r.id,
                                  linkName:r.name,
                                  linkNameEn:r.nameEn,
                                  linkNameCn:r.nameCn,
                                  linkDescription:r.description,
                                  link:r.etcParam1,
                                  company:r.etcParam2?r.etcParam2.toLowerCase().split(';').filter(c=>c!=''):[]
                                }
                              })
      }
    })
    this.showTotalSystemAdmin = (val === "LINK_TOTAL_SYSTEM_all");
  }

  @Watch('codeMenu')
  menuChanged(val:any){
    if(val&&this.validateCompany(val[0].company)){
        this.changedMenu(val[0].originId)
    }
  }


  created(){
    this.selectedMenu = this.isModal ? this.menuName : this.$route.query.MENUNAME.toString()
    api.home.search().then(res=>{
      /* 전사시스템 메뉴 구성 */
      // code 데이터 중 시작단어 LINK_로 설정된 값 필터
      var result:systemCode[] = res.items.filter(r=>r.id.startsWith(this.selectedMenu.split('_')[0])).map(rr=>{
                                return{
                                  originId: rr.id,                                                    // db에 저장된 id값
                                  id : rr.id.split('_')[1],                                           // ex)LINK_TOTAL_SYSTEM | LINK_WORK_SYSTEM 중 TOTAL | WORK 최상위메뉴 값으로 추출
                                  category : rr.etcParam1,                                            // 메뉴 이름(최상위메뉴)
                                  name : rr.name,     
                                  nameEn: rr.nameEn,
                                  nameCn: rr.nameCn,   
                                  subName: rr.id.slice(rr.id.lastIndexOf('_')+1),                     // 메뉴 값 value
                                  company: rr.etcParam2?rr.etcParam2.toLowerCase().split(';').filter(c=>c!=''):[]   // 회사 권한
                                }
                            });

      // 최상위메뉴 Array
      var nav = Array.from(new Set(result.map(r=>r.id)))

      this.codeMenu = nav.map(n=>{
        // id 값 동일한 목록 filter
        var val = result.filter(r=>r.id==n)
        // 하위메뉴용 Array
        var subRes:any;
        if(val){
          // 목록 length 1 이면 하위메뉴 없음
          if(val.length==1){
            subRes = {
              originId:val[0].originId,
              id:n,
              name:val[0].name,
              nameEn:val[0].nameEn,
              nameCn:val[0].nameCn,
              hasChild:false,
              company:val[0].company
            }
          }
          // 목록 length 2 이상이면 하위메뉴로 구성
          else{
            var sub:systemCode[] =[]
            val.map((v:systemCode)=>{
              sub.push({
                originId:v.originId,
                id:v.subName as string,
                name:v.name,
                nameEn:v.nameEn,
                nameCn:v.nameCn,
                company: v.company
              })
            })
            subRes = {
              originId:val[0].originId,
              id:n,
              name:val[0].category,
              hasChild:true,
              children:sub,
            }
          }
        }
        return subRes;
      })
    })
  }

  validateCompany(company:string[]){
    if(company && (company.length==0 || company.includes(this.current.user.comCode.toLowerCase()))){
      return true
    }
    return false
  }
}
